<template>
  <div class="preview" v-if="previewStatus && previewFile">
    <PreviewImage v-if="previewFile.type == 'picture'" :is-mobile="isMobile" />
    <PreviewVideo v-else-if="previewFile.type == 'video'" :is-mobile="isMobile" />
    <!-- pre/next button -->
    <button
      v-show="isShowPreButton"
      class="flex flex-center preview-btn is-left"
      @click="handleLoadPreiviewFile(-1)">
      <Icon path="arrow" name="chevron-left" type="" />
    </button>
    <button
      v-show="isSHowNextButton"
      class="flex flex-center preview-btn is-right"
      @click="handleLoadPreiviewFile(1)">
      <Icon path="arrow" name="chevron-right" type="" />
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Icon from '@/components/icon'
import PreviewImage from './modules/image'
import PreviewVideo from './modules/video'
import { addEvent, removeEvent } from '@/utils/event'

export default {
  name: 'Preview',
  components: {
    Icon,
    PreviewImage,
    PreviewVideo
  },
  data() {
    return {
      isMobile: false
    }
  },
  computed: {
    ...mapGetters([
      'previewFile',
      'previewStatus',
      'currentStore'
    ]),
    playIndex() {
      if (!this.previewFile && this.currentStore.length <= 1) {
        return -1
      }
      
      return this.currentStore.findIndex(({ id }) => this.previewFile.id == id)
    },
    isShowPreButton() {
      return !!this.currentStore[this.playIndex - 1]
    },
    isSHowNextButton() {
      return !!this.currentStore[this.playIndex + 1]
    }
  },
  watch: {
    previewFile(file) {
      const { filename } = this.$route.params

      if (file && filename != file.name) {
        this.$router.push({ name: 'shares', params: { filename: file.name } })
      }
    }
  },
  beforeDestroy() {
    removeEvent(window, 'resize', this.handleResize)
    removeEvent(document.body, 'keyup', this.handleKeyup)
  },
  mounted() {
    this.handleResize()
    addEvent(window, 'resize', this.handleResize)
    addEvent(document.body, 'keyup', this.handleKeyup)
  },
  methods: {
    handleResize() {
      const { clientWidth, clientHeight } = document.body
      
      this.isMobile = clientWidth < 1024 || clientHeight < 576
    },
    handleLoadPreiviewFile(val) {
      this.$store.commit('INIT_PREVIEW', this.currentStore[this.playIndex + val])
    },
    handleKeyup(e){
      if(e.keyCode==37) {
        this.isShowPreButton && this.handleLoadPreiviewFile(-1)
      } else if(e.keyCode==39) {
        this.isSHowNextButton && this.handleLoadPreiviewFile(1)
      } else if (e.keyCode==27) {
        const { shareId } = this.$route.params
        this.$router.push(`/shares/${shareId}`)
      }
    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');
  .preview {
    position: relative;
    width: 100vw;
    height: 100%;
    & &-btn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
      border: none;
      outline: none;
      padding: 0;
      margin: 0;
      height: 36px;
      width: 36px;
      cursor: pointer;
      transition: 0.3s;
      border-radius: 50%;
      text-align: center;
      font-size: 24px;
      color: @white;
      background-color: var(--background-contrl, @grey-400);
      &.is-left {
        left: 10px;
      }
      &.is-right {
        right: 10px;
      }
      &.is-disabled {
        opacity: .5;
        cursor: wait;
      }
    }
  }
</style>